export enum ChartDataFormat {
	TOTAL,
	PERCENTAGE
}
